import { Injectable } from '@angular/core';
import { FormControl, ValidatorFn, Validators, FormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class CustomValidatorService extends Validators {

    constructor() {
        super();
    }

    /**
       * @desc To validate emailid
       * @param {FormControl} control
       * @returns null or object
       * 
    */
    static validateEmail(control: FormControl): any {
        var regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*(\.[A-Za-z]{2,})$/;
        var found = regex.test(control.value);
        return found ? null : { 'email': true };
    }

    /**
       * @desc To validate mobile number
       * @param {FormControl} control
       * @returns null or object
    */
    static validateMobile(control: FormControl): any {
        var regex = /^[1-9]{1}[0-9]{9}$/;
        var found = regex.test(control.value);
        return found ? null : { 'mobile': true };
    }

    static validateAadhar(number): any {
        var regex = /^[0-9]{12}$/;
        var found = regex.test(number);
        return found ? true : false;
    }

    static validateMobileInPopup(number): any {
        var regex = /^[1-9]{1}[0-9]{9}$/;
        var found = regex.test(number);
        return found ? true : false;
    }

    static validatePan(number): any {
        var regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        var found = regex.test(number);
        return found ? true : false;
    }

    static validateConsentPin(control: FormControl): any {
        var regex = /^[0-9]{6}$/;
        var found = regex.test(control.value);
        return found ? null : { 'consentPin': true };
    }

    static validateCRN(number): any {
        var regex = /^[0-9]{6,}$/;
        var found = regex.test(number);
        return found ? true : false;
    }
    static validateName(control: FormControl): any {
        var regex = /^[A-Za-z]{3,}$/;
        var found = regex.test(control.value);
        return found ? null : {'name': true};
    }
    static validateAccountNumber(control: FormControl): any {
        var regex = /^[0-9]{6,}$/;
        var found = regex.test(control.value);
        return found ? null : {'name': true};
    }
    /**
       * @desc To validate password
       * @param {FormControl} control
       * @returns null or object
    */
    static validatePassword(control: FormControl): any {
        var regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
        var found = regex.test(control.value);
        return found ? null : { 'password': true };
    }

    /**
        * @desc To validate pin code
        * @param {FormControl} control
        * @returns null or object
    */
    static NonNegative(control: FormControl): any {
        if (control.value == null) {
            return null;
        }
        return control.value >= 0 ? null : { 'negative': true };
    }
}

